import { CustomFieldsProvider } from './context/CustomFieldsProvider'
import { CustomFieldsMain } from './components/CustomFieldsMain'

export function CustomFields() {
  return (
    <CustomFieldsProvider>
      <CustomFieldsMain />
    </CustomFieldsProvider>
  )
}
